define(
  'ThemeHelper.EntryPoint',
  [
    'Header.EntryPoint',
    'ProductDetailsPage.EntryPoint'
  ],
  function (
    HeaderEntryPoint,
    ProductDetailsPageEntryPoint
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        HeaderEntryPoint.mountToApp(container);
        ProductDetailsPageEntryPoint.mountToApp(container);
      }
    };
  });
